import React, { useState, useEffect } from "react";
import { Col, Row, Card, Form, FloatButton, Tabs } from "antd";
import columnsCase90 from "./data/Columns_Case90";
import TablePCMoble from "./data/Table_PC_Moble";
import { main_wdr } from "./api/apiCent90";
import { ArrowUpOutlined } from "@ant-design/icons";
import ModalAccept from "./modal_all/ModalAccept";
import ModalEMS from "./modal_all/ModalEMS";
import ModalPrintFinanceReport from "./modal_all/ModalPrintFinanceReport";
import ModalCheckAllCases from "./modal_all/ModalCheckAllCases";
// import MoveJobContent from "./MoveJobContent";
// import CloseJobContent from "./CloseJobContent";
import OffRoundLetterContent from "./OffRoundLetterContent";
import axios from "axios";
import dayjs from "dayjs";

/**
 * TableContent
 * เนื้อหาของ tab "รับงาน" / "คืนงาน" (มีตาราง + ปุ่มค้นหา + ปุ่มยืนยันรับเคสถ้าเป็นรับงาน)
 *
 * props:
 *  - caseType    : "1" = ที่ดิน, "2" = รถ
 *  - showAccept  : true = รับงาน (มีปุ่มยืนยันรับเคส), false = คืนงาน (ไม่มีปุ่ม)
 */
function TableContent({ caseType, showAccept }) {
  const [form] = Form.useForm(); //กำหนด form ก่อนใช้งาน
  const [dataMainS4, setDataMainS4] = useState([]); //ตาราง
  const [selectedRowKeys, setSelectedRowKeys] = useState([]); //เก็บเลือกแถวของตาราง
  const [dataRowKeys, setDataRowKeys] = useState([]); //เก็บเลือกแถวของตาราง ข้อมูล

  //เลือกแถวของตาราง
  const rowSelection = {
    selectedRowKeys,
    onChange: (newSelectedRowKeys, selectedRows) => {
      setSelectedRowKeys(newSelectedRowKeys);
      setDataRowKeys(selectedRows);
    },
  };

  // true = รอบการส่ง (roundDate) ถึงกำหนดแล้ว (<= วันนี้) -> อนุญาตให้กดปุ่มได้
  // ถ้ายังไม่ถึงรอบ (roundDate > วันนี้) -> กดยกเลิก/ยืนยันรับเคสไม่ได้
  const isRoundReached = (item) => {
    if (!item || !item.roundDate) return false;
    return !dayjs(item.roundDate)
      .startOf("day")
      .isAfter(dayjs().startOf("day"));
  };

  // แปลง roundDate เป็น timestamp ของ "วัน" (ตัดเวลาออก) เพื่อใช้เทียบ/จัดกลุ่มรอบการส่ง
  const roundDayTime = (item) => {
    if (!item || !item.roundDate) return null;
    const d = new Date(item.roundDate);
    if (isNaN(d.getTime())) return null;
    return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
  };

  // กรองข้อมูลเฉพาะ caseType ของ tab นี้
  const applyFilter = (dataB) => {
    // flagWcc = true รับเคสไปแล้ว -> ไม่แสดง
    const dataC = dataB.filter((item) => item.flagWcc !== true);
    const dataD = dataC.filter(
      (item) => String(item.caseType) === String(caseType)
    );

    // แสดงทีละรอบการส่ง: เอาเฉพาะรอบ (roundDate) ที่เก่าที่สุดก่อน
    // เมื่อเคสรอบนั้นถูกคืนงาน/รับเคสจนหมด รอบถัดไปจึงจะแสดงขึ้นมาแทน
    const roundTimes = dataD
      .map(roundDayTime)
      .filter((t) => t !== null);
    if (roundTimes.length === 0) return dataD;
    const earliest = Math.min(...roundTimes);
    return dataD.filter((item) => roundDayTime(item) === earliest);
  };

  const loadData = async () => {
    try {
      const res = await axios.post(main_wdr, {
        // statuses: ["3", "4", "5", "6", "7"],
        statuses: [3, 4, 5, 6, 7],
        user: "admin888",
        flagHdpayment: true,
      });
      console.log("res.data", res.data);
      const dataB = res.data.data;
      setDataMainS4(applyFilter(dataB));
    } catch (err) {
      console.log(err);
    }
  };

  // โหลดข้อมูลทันทีตอน tab นี้ถูก render ครั้งแรก
  useEffect(() => {
    loadData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ดึง columns ทั้งหมดจาก columnsCase90 แล้วตัดคอลัมน์ "ยกเลิกเคส" (key: backToS1) ออกเฉพาะหน้ารับงาน
  const allColumns = columnsCase90(() => loadData());
  const displayColumns = showAccept
    ? allColumns.filter((col) => col.key !== "backToS1")
    : allColumns;

  // ตารางแสดงเฉพาะรอบเก่าสุดอยู่แล้ว (จาก applyFilter) ทุกแถวจึงเป็นรอบเดียวกัน
  // รอบนี้ถึงกำหนดหรือยัง -> ใช้คุมปุ่ม "ยืนยันรับเคส"
  const roundReached =
    dataMainS4.length > 0 && isRoundReached(dataMainS4[0]);

  return (
    <Form
      layout="vertical"
      name="basic"
      form={form}
      autoComplete="off"
      style={{ width: "90%", marginLeft: "5%" }}
    >
      <Row>
        <Col
          md={24}
          xs={24}
          style={{ textAlign: "center", marginTop: "20px", padding: 0 }}
        >
          <Card
            title={
              showAccept ? (
                <span style={{ fontWeight: 400, color: "#8c8c8c" }}>
                  เลือกแล้ว {selectedRowKeys.length} รายการ
                </span>
              ) : null
            }
            extra={
              showAccept && (
                <ModalAccept
                  caseType={caseType}
                  dataA={dataRowKeys}
                  selectedRowKeys={selectedRowKeys}
                  onSuccess={() => loadData()}
                  disabled={!roundReached}
                />
              )
            }
          >
            <TablePCMoble
              ColumnsCase90={displayColumns}
              DataSourceTest={dataMainS4}
              rowSelection={showAccept ? rowSelection : undefined}
              rowKey="contno"
            />
          </Card>
        </Col>
      </Row>
    </Form>
  );
}

/**
 * LetterContent
 * เนื้อหาของ tab "ออกจดหมาย" ไม่มีตาราง มีแค่ปุ่ม EMS
 *
 * หมายเหตุ: เดิม ModalEMS รับ props dataA / selectedRowKeys จากแถวที่เลือกในตาราง
 * เมื่อ tab นี้ไม่มีตารางแล้ว ต้องเช็คโค้ดใน ModalEMS ว่าเลือกเคสที่จะออกจดหมาย
 * จากที่ไหน (เช่น ดึงเองภายใน modal ตาม caseType) แล้วปรับ props ให้ตรงกัน
 */
function LetterContent({ caseType }) {
  return (
    <Row>
      <Col md={24} xs={24} style={{ textAlign: "center", marginTop: "40px" }}>
        <ModalEMS caseType={caseType} />
      </Col>
    </Row>
  );
}

// สีประจำกลุ่ม ใช้ทำให้ tab ที่ดิน/รถ ดูแตกต่างกันชัดเจน
const LAND_COLOR = "#0C447C"; // ที่ดิน = ฟ้า
const CAR_COLOR = "#27500A"; // รถ = เขียว

// เส้นแบ่งกลุ่ม tab: ใส่ border-right ให้ tab สุดท้ายของแต่ละกลุ่ม
const DIVIDER_STYLE = {
  borderRight: "1px solid #d9d9d9",
  paddingRight: "16px",
  marginRight: "4px",
};

function TabelSentS4() {
  const items = [
    {
      key: "off-round-letter",
      label: <span style={DIVIDER_STYLE}>จดหมายออกมือ</span>,
      children: <OffRoundLetterContent />,
    },
    // {
    //   key: "move-job",
    //   label: <span>โยกงาน</span>,
    //   children: <MoveJobContent />,
    // },
    // {
    //   key: "close-job",
    //   label: <span style={DIVIDER_STYLE}>ปิดงาน-โยกงาน</span>,
    //   children: <CloseJobContent />,
    // },
    {
      key: "land-return",
      label: <span style={{ color: LAND_COLOR }}>คืนงานเร่งรัดชาย-ที่ดิน</span>,
      children: <TableContent caseType="1" showAccept={false} />,
    },
    {
      key: "land-receive",
      label: <span style={{ color: LAND_COLOR }}>รับเคสออกจดหมาย-ที่ดิน</span>,
      children: <TableContent caseType="1" showAccept={true} />,
    },
    {
      key: "land-letter",
      label: (
        <span style={{ color: LAND_COLOR, ...DIVIDER_STYLE }}>
          พิมพ์ กับยิงEMS-ที่ดิน
        </span>
      ),
      children: <LetterContent caseType="1" />,
    },
    {
      key: "car-return",
      label: <span style={{ color: CAR_COLOR }}>คืนงานเร่งรัดชาย-รถ</span>,
      children: <TableContent caseType="2" showAccept={false} />,
    },
    {
      key: "car-receive",
      label: <span style={{ color: CAR_COLOR }}>รับเคสออกจดหมาย-รถ</span>,
      children: <TableContent caseType="2" showAccept={true} />,
    },

    {
      key: "car-letter",
      label: <span style={{ color: CAR_COLOR }}>พิมพ์ กับยิงEMS-รถ </span>,
      children: <LetterContent caseType="2" />,
    },
  ];

  return (
    <div>
      <Row>
        <Col md={24} xs={24} style={{ textAlign: "center", marginTop: "20px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap", // มือถือ: หัวข้ออยู่แถวบน ปุ่มลงมาแถวล่าง
              gap: "16px",
            }}
          >
            <h1 style={{ margin: 0, fontSize: "clamp(20px, 5vw, 32px)" }}>
              CEO อนุมัติ ตรวจเคสค้างเกิน 90 วัน
            </h1>
            <ModalPrintFinanceReport />
            <ModalCheckAllCases />
          </div>
          <br />
        </Col>

        <Col md={24} xs={24}>
          <Tabs
            defaultActiveKey="land-return"
            items={items}
            centered
            destroyInactiveTabPane // สลับ tab แล้ว mount ใหม่ทุกครั้ง -> โหลดข้อมูลใหม่อัตโนมัติ
          />
        </Col>

        <Col md={24} xs={24} className="mobile-only">
          <FloatButton
            style={{ insetBlockEnd: 120 }}
            icon={<ArrowUpOutlined />}
            onClick={() => {
              window.scrollTo({
                top: 0,
                behavior: "smooth",
              });
            }}
          />
        </Col>
      </Row>
    </div>
  );
}

export default TabelSentS4;
